import ProductGrid from "./components/home/product/Product";
import './globals.css'

export default function Home() {
  return (
    <div>
      <ProductGrid />
    </div>
  );
}
